import Vue from 'vue'
import router from './routers'
import store from '@/store' //vuex
import './registerServiceWorker'
import Common from '@/components/index.js'
import ElementUI from 'element-ui'
import multiCascader from 'multi-cascader-base-ele'
import 'styles/element-theme.scss'
import 'styles/reset.scss'
import "@/assets/font/iconfont.css"
import axios from "axios"
import App from './App.vue'
import api from './api/index'
import UI from '@/components/ui'
import Widgets from '@/components/widgets'
import { setFavicon, md5, formatMenuAccess } from '@/common/utils/index.js'
import './common/app.directives.js'
import '@/common/app.mixin.js'
import '@/common/app.directives.js'
import VueCompositionAPI from '@vue/composition-api'
import VueClipboard from 'vue-clipboard2'
import VueCropper from 'vue-cropper'

Vue.use(VueCompositionAPI)
setFavicon()
Vue.use(Common)
Vue.use(ElementUI)
Vue.use(multiCascader)
Vue.use(UI)
Vue.use(Widgets)
Vue.use(VueCropper)
Vue.use(VueClipboard)

Vue.prototype.imgSig = 'http://zk-img.oss-cn-qingdao.aliyuncs.com/h5/cyn/';
(window as any).eventBus = new Vue()

Vue.config.productionTip = false
Vue.prototype.router = router
Vue.prototype.axios = axios
Vue.prototype.api = api as any

(window as any).ywArr = [];
(window as any).ywArr2 = {};

Vue.prototype.getSsaa = formatMenuAccess

Vue.prototype.opPrCont = function(id){
	window.open(localStorage.getItem("URL")+"/#/prcent?id="+id+'&type=prj');
};
Vue.prototype.checkLeve = function(id){
  let menuAccess = [];
  try {
    menuAccess = JSON.parse(localStorage.getItem("access")).menu_banner;
  } catch (error) {
    console.log(error)
  }

  let ceckFn = da=>{
    for(let i=0,n=da.length;i<n;i++){
      if(da[i].id==id){
        return true
      }
    
      if(da[i].child){
         if(ceckFn(da[i].child)){
           return true
         }
      }
    }
    return false;
  }
  return ceckFn(menuAccess)
};

Vue.prototype.getBrand = (fn)=>{
  api.fastappconfInfo({
    config_name:'brand'
  }).then(da=>{
    if(da=='error'){return}

    fn(da)
  })
  
}
Vue.prototype.MD5 = md5
//路由跳转前做判断
router.beforeEach((to, from, next) => {
	document.title = (to.meta.pagetitle || to.meta.title || to.meta.name) + '-狮圈儿运营管理平台';

	next();
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
